// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","449":"notFound","731":"kubosView","939":"kubosCreate"}[chunkId] + "." + {"296":"65161f28","449":"eb6919dd","731":"40499e89","939":"3bef6518"}[chunkId] + ".js";
};